import request from '@/utils/request'
export const queryPage = '/icps/system/sign/dataCollection/rawCutTo/QueryPage'
export const Download = '/icps/system/sign/dataCollection/rawCutTo/exportList'
export function getConsignmentIssue(data) {
  return request({
    url: '/icps/system/sign/dataCollection/rawCutToLog/QueryPage',
    method: 'post',
    data
  })
}